module.exports = __webpack_public_path__ + "static/media/r28.0dd678a8.png";